import EN from "locales/en";
import DE from "locales/de";

export { EN, DE };

export default { EN, DE };
